import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalRequiredConditionPossibleGroupTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalRequiredConditionPossibleGroupTag';
/**
 * 「プロジェクトで求めていること」で利用する相談可能な条件タグ
 * @param props
 * @constructor
 */
export const RfpProfessionalRequiredConditionNegotiablePossibleGroupTag = (props) => {
    const { className = '', isNegotiableBudget, isNegotiableEndDate, isNegotiableStartDate, } = props;
    const items = useMemo(() => [
        { isPossible: isNegotiableBudget, label: '予算' },
        { isPossible: isNegotiableStartDate, label: 'PJ開始時期' },
        { isPossible: isNegotiableEndDate, label: 'PJ完了時期' },
    ], [isNegotiableBudget, isNegotiableEndDate, isNegotiableStartDate]);
    return (_jsx(RfpProfessionalRequiredConditionPossibleGroupTag, { className: className, items: items }));
};
